import React from "react";
import Loader from "../../../../../../../components/Loader/Loader";
import { Workshop } from "../../../../types";
import { getPadTitle } from "../../../../utils";
import CardPad from "../../../../WorkshopPreview/CardPad/CardPad";
import { useGetWorkshopPad } from "../../../api/useQueries";

import "./WorkshopDetails.scss";
import { defineMessages, useIntl } from "react-intl";
import { Pagetype } from "../../../../../../../interfaces/Config";
import { commonMessages } from "../../../../../../../utils/messages";
import { useUrl } from "../../../../../../../hooks/usePage";
import useOnlineStatus from "../../../../../../../hooks/useOnlineStatus";
import classNames from "classnames";
import { ROUTES } from "../../../../../../../design-system-components/WorkmodeLayout/const";
import { Button } from "@evidenceb/athena-common/design-system/Button";

type Props = {
    workshopInPreview: Workshop;
};
const WorkshopDetails = ({ workshopInPreview }: Props) => {
    const getWorkshopPads = useGetWorkshopPad(workshopInPreview.id);
    const intl = useIntl();
    const isOnline = useOnlineStatus();
    const urlMode = useUrl(Pagetype.WORKMODE_WORKSHOP);
    // TODO handle error
    if (getWorkshopPads.isError) return null;

    const collaborativePads = getWorkshopPads.isSuccess
        ? getWorkshopPads.data
        : undefined;
    return (
        <div
            className={classNames("workshop-details", {
                "--is-loading": getWorkshopPads.isLoading,
            })}
        >
            <Loader isLoading={getWorkshopPads.isLoading} />
            {!getWorkshopPads.isLoading &&
                (!getWorkshopPads || !collaborativePads?.length) && (
                    <div>
                        <p>
                            {intl.formatMessage(
                                messages.workshopSidePlaceholder
                            )}
                        </p>
                        <Button
                            label={intl.formatMessage(commonMessages.share)}
                            icons={[
                                {
                                    path: "add",
                                },
                            ]}
                            asRouterLink={{
                                to: `${urlMode}/${ROUTES.createPad}/${workshopInPreview.id}`,
                            }}
                            disabled={!isOnline}
                        />
                    </div>
                )}
            {collaborativePads &&
                collaborativePads.map((pad) => (
                    <CardPad
                        key={pad.assigned_resource.resource_id}
                        label={getPadTitle(pad.assigned_resource.resource_id)}
                        collaborators={pad.students}
                        padId={pad.assigned_resource.resource_id}
                        workshopId={workshopInPreview.id}
                    />
                ))}
        </div>
    );
};
export default WorkshopDetails;

const messages = defineMessages({
    workshopSidePlaceholder: {
        id: "workshop-side-placeholder",
        defaultMessage:
            "Select a workshop to get an overview of its recipients and their progress.",
    },
});
